import React from 'react';
import { ButtonIcon } from '../ButtonIcon';
import { Download } from '../buttons';
import { AddUserSVG, RefreshSVG } from '../svg';
import '../../styles/sass/global/components/filters.scss';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import enabledPages from '@core/constants/pages/enabledPages';
import { useTranslation } from 'react-i18next';
import { palette } from '../../styles/theme';

export function HeaderTitle ({ title, add, addTitle, reset, icon, download, buttonText, href, handleOnClick, UIProps, margBottom }) {
    const { t } = useTranslation();
    const showButton = buttonText && (href || handleOnClick);

    return (
        <Box width='100%' display='flex' alignItems='start' justifyContent='space-between' marginTop='1.5rem' >
            <Box display='flex' alignItems='center' style={{ marginLeft: '2.231rem', marginBottom: margBottom || '0rem' }}>
                <Box>{icon}</Box>
                <Typography variant='h6' className='headerTitle_typography--title'>{title}</Typography>

            </Box>
            <Box style={{ marginRight: '2.231rem' }}>
                {download && (<ButtonIcon
                    title={t('downloadExcel')}
                    onClick={download}
                    icon={(<Download/>)}
                    disabled={UIProps.isLoading}
                />)}
                {
                    reset && (
                        <ButtonIcon
                            className='mr-0 mb-0'
                            title={t('reset')}
                            icon={(<RefreshSVG style={{ width: '1.846rem', height: '1.846rem' }}/>)}
                            onClick={reset}
                        />
                    )
                }
                { enabledPages.enableUsersActions && add && (
                    <ButtonIcon
                        className='mr-0 mb-0'
                        title={addTitle}
                        icon={(<AddUserSVG style={{ width: '1.846rem', height: '1.846rem' }}/>)}
                        onClick={add}
                    />
                )}

                {showButton && (
                    <Button href={href} className="button_custom--header w-auto px-4 py-3" onClick={handleOnClick} disabled={UIProps.isLoading}>
                        {UIProps.isLoading ? <CircularProgress size="1.846rem" style={{ color: palette.white }} /> : buttonText}
                    </Button>

                )}
            </Box>
        </Box>
    );
}
